import React, { useState, useEffect } from "react";
import logo from "./logo.svg";
import "../App.css";
import Header from "../component/Header";
import modelDataEN from "../data/en/model.json";
import modelDataTH from "../data/th/model.json";
import modelDataVN from "../data/vn/model.json";
import modelDataAR from "../data/ar/model.json";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
let modelData: any = {};
function Attention() {
  let { t } = useTranslation();
  if (sessionStorage.getItem("lang") === "th") {
    modelData = modelDataTH;
  } else if (sessionStorage.getItem("lang") === "vn") {
    modelData = modelDataVN;
  } else if (sessionStorage.getItem("lang") === "ar") {
    modelData = modelDataAR;
  } else {
    modelData = modelDataEN;
  }
  const [data, setData] = useState({ dimenssion: "" });
  const filter: any = modelData.filter((item: any) => {
    return item.id.toString() === sessionStorage.getItem("model");
  });
  const [item, setItem] = useState(filter);
  useEffect(() => {
    if (item.length > 0) {
      setData(item[0]);
    }
  }, []);
  return (
    <div className="App container-fuild">
      <Header />
      <div className="container-fuild p-2  ">
        <div className="container-content c-attention">
          <div className="container-block ">
            <div>
              <div className="container max-1024 m-auto py-0">
                <div className="row align-items-center">
                  <div className="col-12 col-sm-12 col-md-5">
                    <img
                      src={data ? data?.dimenssion : ""}
                      alt=""
                      className="w-100"
                    />
                  </div>
                  <div className="col-12 col-sm-12 col-md-7 attention text-start">
                    <div className="bubble px-4 text-end ms-auto">{parse(t("dimenssion_title"))}</div>
                    <p className="mt-3 text-end">{parse(t("dimenssion_desc"))}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ul className="step">
            <li>1</li>
            <li>2</li>
            <li>3</li>
            <li className="active">4</li>
            <li>5</li>
          </ul>
        </div>
        <div className="row w-100 m-0">
          <div className="col-12 text-center">
            <a
              className="btn btn-back"
              href="/ae/ar/choose-your-refrigerator/models"
            >
              {t("back")}
            </a>
            <a
              className="btn btn-next"
              href="/ae/ar/choose-your-refrigerator/finish"
            >
              {t("next")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Attention;
